// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4e-1";
export var standaloneTable = "_4e-0";